import { actionType } from "../utils/helpers/generalHelper";
import * as ModalConstants from "../constants/modal.constant";

export const showModal = (modalType, data) => {
  return actionType(ModalConstants.SHOW_MODAL, {
    data: data,
    type: modalType,
  });
};

export const hideModal = () => {
  return actionType(ModalConstants.HIDE_MODAL);
};

export const modalActionLoadingState = (loading) => {
  return actionType(ModalConstants.MODAL_ACTION_LOADING, {
    data: loading,
  });
};
